import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

// Lightweight selection bar shown below the Members header
// Props are optional; defaults keep it purely presentational
const TeamV2MembersSelectionBar = ({
    allSelected = false,
    onToggleAll = () => { },
    selectedCount,
    totalCount
}) => {
    return (
        <Box sx={{ padding: 2, pt: 0 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#ffff',
                    borderRadius: '0.5rem',
                    padding: '0.25rem 1rem',
                    width: { xs: '30%', sm: 180 }
                }}
            >
                <Checkbox
                    checked={allSelected}
                    onChange={onToggleAll}
                    sx={{
                        color: '#b0b0b0',
                        padding: '0',
                        marginRight: '0.5rem',
                        '&.Mui-checked': {
                            color: '#757575'
                        },
                        '& .MuiSvgIcon-root': {
                            borderRadius: '0.375rem',
                            backgroundColor: '#fff'
                        }
                    }}
                />
                <Typography sx={{ fontSize: '0.8rem', color: '#555', fontWeight: 600 }}>
                    Select all
                </Typography>
            </Box>
        </Box>
    );
};

export default TeamV2MembersSelectionBar;


